import Alert from 'bootstrap/js/dist/alert';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';

import ClipboardJS from 'clipboard';
import Cuttr from 'cuttr';
import Choices from 'choices.js';
import { Fancybox } from '@fancyapps/ui';
import Mark from 'mark.js';
import SmoothScroll from 'smooth-scroll';
import svg4everybody from 'svg4everybody';
import Swiper, { Navigation, Pagination } from 'swiper';

window.App = {
  cache: {
    loadmoreCounter: 0,
    loadmoreContentContainer: document.querySelector('.js-content-container'),
    loadmoreTriggerContainer: document.querySelector('.js-pagination-container')
  },

  scrollbar: function() {
    document.documentElement.style.setProperty('--custom-scrollbar', `${window.innerWidth - document.body.clientWidth}px`);
  },

  inits: function() {
    App.carouselsInit();
    App.clipboardInit();
    App.cuttrInit();
    App.galleriesInit();
    App.loadMoreInit();
    App.markInit();
    App.modalsInit();
    App.redirectInit();
    App.searchDropdownFocusInit();
    App.searchDropdownVisibilityInit();
    App.searchValidationInit();
    App.selectsInit();
    App.stickiesInit();
    App.svg4everybodyInit();
    App.smoothScrollInit();
    App.topInit();
    App.notificationsInit();
  },

  carouselsInit: function() {
    var swipers = document.querySelectorAll('.js-carousel');

    swipers.forEach(function(element) {
      var options = {
        modules: [Navigation, Pagination]
      }
      var swiper = new Swiper(element, Object.assign(options, JSON.parse(element.getAttribute('data-swiper'))));
    });
  },

  clipboardInit: function() {
    var triggers = document.querySelectorAll('.js-clipboard-trigger');
    var clipboard = new ClipboardJS(triggers);
    var timeout;

    clipboard.on('success', function(e) {
      var alert = e.trigger.closest('.js-clipboard').querySelector('.js-clipboard-alert');
      var close = alert.querySelector('button');

      clearTimeout(timeout);
      alert.classList.add('show');

      timeout = setTimeout(function() {
        alert.classList.remove('show');
      }, 2000);

      close.addEventListener('click', function(e) {
        alert.classList.remove('show');
      });
    });
  },

  cuttrInit: function() {
    var cuttrs = document.querySelectorAll('.js-cuttr:not([data-cuttr-index])');

    cuttrs.forEach(function(cuttr) {
      new Cuttr(cuttr, {
        truncate: 'words',
        length: 35,
        readMore: true,
        readMoreText: 'Číst více',
        readLessText: 'Číst méně',
        readMoreBtnTag: 'a',
        // afterTruncate: function(){
        //   this.classList.remove('cuttr--expanded');
        // },
        afterExpand: function() {
          this.classList.add('cuttr--expanded');
          window.App.markInit();
        }
      });
    });
  },

  galleriesInit: function() {
    Fancybox.bind('[data-fancybox]', {
      Thumbs: false
    });
  },

  loadMore: function(trigger, infinite) {
    var xhr = new XMLHttpRequest();

    xhr.open('POST', trigger.href, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.responseType = 'json';
    xhr.onreadystatechange = function() {
      if(this.readyState == 4 && this.status == 200) {
        window.App.cache.loadmoreContentContainer.insertAdjacentHTML('beforeend', this.response.items);
        window.App.cache.loadmoreTriggerContainer.innerHTML = this.response.pagination;
        window.App.clipboardInit();
        window.App.cuttrInit();

        if(!infinite) {
          if(window.App.cache.loadmoreCounter == 0) {
            history.pushState('reload', '', trigger.href);
          } else {
            history.replaceState('reload', '', trigger.href);
          }

          window.App.cache.loadmoreCounter++;
        }
      }
    }
    xhr.send(null);
  },

  loadMoreInit: function() {
    if(typeof(window.App.cache.loadmoreContentContainer) != 'undefined' && window.App.cache.loadmoreContentContainer != null && typeof(window.App.cache.loadmoreTriggerContainer) != 'undefined' && window.App.cache.loadmoreTriggerContainer != null) {
      var infinite = window.App.cache.loadmoreTriggerContainer.classList.contains('js-infinite');

      if(infinite) {
        var observer = new IntersectionObserver(function([e]) {
          if(e.isIntersecting) {
            var trigger = e.target.querySelector('.js-pagination-trigger');

            if(typeof(trigger) != 'undefined' && trigger) {
              trigger.click();
            }
          }
        }, {
          rootMargin: '0px 0px 25% 0px',
          threshold: [1]
        });

        observer.observe(window.App.cache.loadmoreTriggerContainer);
      }

      window.App.cache.loadmoreTriggerContainer.addEventListener('click', function(e) {
        e.preventDefault();

        if(e.target.classList.contains('js-pagination-trigger')) {
          e.target.closest('.js-pagination').classList.add('active');
          window.App.loadMore(e.target, infinite);
        }
      });

      if(!infinite) {
        history.replaceState('reload', '', window.location.href);

        window.addEventListener('popstate', function(e) {
          if(e.state === 'reload') {
            window.location.reload();
          }
        });
      }
    }
  },

  markInit: function() {
    var keyword = document.querySelector('.js-search-keyword');
    var context = document.querySelectorAll('.js-search-context');

    if(typeof(keyword) != 'undefined' && keyword != null) {
      var instance = new Mark(context);

      instance.mark(keyword.innerHTML, {
        exclude: ['.cuttr__readmore']
      });
    }
  },

  modalsInit: function() {
    var modals = document.querySelectorAll('.js-modal');

    modals.forEach(function(modal) {
      modal.addEventListener('show.bs.modal', function(e) {
        var trigger = e.relatedTarget;

        this.querySelector('.js-modal-title').textContent = trigger.dataset.title;
        this.querySelector('.js-modal-body').textContent = trigger.dataset.body;
        this.querySelector('.js-modal-url').href = trigger.dataset.url;
      });
    });
  },

  redirectInit: function() {
    var redirect = document.querySelector('.js-redirect');

    if(typeof(redirect) != 'undefined' && redirect != null) {
      var seconds = redirect.textContent;
      var interval = setInterval(function() {
        seconds--;
        redirect.textContent = seconds;

        if(seconds == 0) {
          window.location.href = redirect.dataset.target;
          clearInterval(interval);
        }
      }, 1000);
    }
  },

  searchDropdownFocusInit: function() {
    var search = document.querySelector('.js-search');

    if(typeof(search) != 'undefined' && search != null) {
      search.addEventListener('shown.bs.dropdown', function() {
        search.querySelector('input').focus();
      });
    }
  },

  searchDropdownVisibilityInit: function() {
    var header = document.querySelector('.js-header');
    var search = document.querySelector('.js-search-toggler');

    if(typeof(search) != 'undefined' && search != null && typeof(header) != 'undefined' && header != null) {
      var dropdown = new Dropdown(search);
      var observer = new IntersectionObserver(function([e]) {
        if (!e.isIntersecting) {
          dropdown.hide();
        }
      }, {
        rootMargin: '70px 0px 0px 0px',
        threshold: [1]
      });

      observer.observe(header);
    }
  },

  searchValidationInit: function() {
    var search = document.querySelector('.js-search-form');

    if(typeof(search) != 'undefined' && search != null) {
      var observer = new MutationObserver(function(record) {
        if(record[0].type === 'attributes' && record[0].attributeName === 'novalidate') {
          search.removeAttribute('novalidate');
        }
      });

      observer.observe(search, {
        attributes: true
      });
    }
  },

  selectsInit: function() {
    var selects = document.querySelectorAll('.js-select');

    selects.forEach(function(select) {
      new Choices(select, {
        searchEnabled: false,
        position: 'bottom',
        shouldSort: false,
        itemSelectText: ''
      });

      select.addEventListener('showDropdown', function(e) {
        var choice = e.target.closest('.choices');
        var rect = choice.getBoundingClientRect();

        if(rect.x + rect.width > 200) {
          choice.classList.add('choice--start');
        } else {
          choice.classList.add('choice--end');
        }
      }, false);

      select.addEventListener('hideDropdown', function(e) {
        e.target.closest('.choices').classList.remove('choice--start', 'choice--end');
      }, false);

      if(select.classList.contains('js-select-links')) {
        select.addEventListener('change', function(e) {
          window.location.href = e.detail.value;
        }, false);
      }
    });
  },

  stickiesInit: function () {
    var stickies = document.querySelectorAll('.js-sticky');

    stickies.forEach(function(sticky) {
      var observer = new IntersectionObserver(function([e]) {
        e.target.classList.toggle('is-stuck', e.intersectionRatio > 0 && e.intersectionRatio < 1 && e.intersectionRect.top < 2);
      }, {
        rootMargin: '-1px 0px 0px 0px',
        threshold: [1]
      });

      observer.observe(sticky);
    });
  },

  svg4everybodyInit: function() {
    svg4everybody({
      polyfill: true
    });
  },

  smoothScrollInit: function () {
    new SmoothScroll('[data-scroll]', {
      speedAsDuration: true,
      updateURL: false
    });
  },

  topInit: function() {
    var trigger = document.querySelector('.js-top');

    if(typeof(trigger) != 'undefined' && trigger != null) {
      var observer = new IntersectionObserver(function([e]) {
        if (e.isIntersecting) {
          e.target.classList.add('active');
        } else {
          e.target.classList.remove('active');
        }
      });
      observer.observe(trigger);
    }
  },

  notificationsInit: function() {
    function urlBase64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
      const rawData = atob(base64);
      return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
    }

    const button = document.querySelector('.js-activateNotifications');
    if (!button) return;

    const label = button.querySelector('.c-Button-label');
    if (!label) return;

    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('❌ Push notifikace nejsou podporovány');
      label.textContent = 'Nepodporováno';
      return;
    }

    let currentSubscription = null;

    async function updateButton() {
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) {
          label.textContent = 'Aktivovat';
          return;
        }

        currentSubscription = await registration.pushManager.getSubscription();

        if (currentSubscription) {
          label.textContent = 'Odhlásit notifikace';
        } else {
          label.textContent = 'Aktivovat notifikace';
        }
      } catch (err) {
        console.error('❌ Chyba při kontrole subscription:', err);
      }
    }

    updateButton();

    button.addEventListener('click', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');

        if (currentSubscription) {
          await currentSubscription.unsubscribe();

          await fetch(notificationUnsubsribeUrl, {
            method: 'POST',
            body: JSON.stringify(currentSubscription),
            headers: { 'Content-Type': 'application/json' }
          });

          console.log('ℹ️ Notifikace odhlášeny');
          currentSubscription = null;
        } else {
          const permission = await Notification.requestPermission();
          if (permission !== 'granted') {
            alert('Notifikace nebyly povoleny.');
            return;
          }

          currentSubscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
          });

          await fetch(notificationUrl, {
            method: 'POST',
            body: JSON.stringify(currentSubscription),
            headers: { 'Content-Type': 'application/json' }
          });

          console.log('✅ Notifikace aktivovány');
        }

        updateButton();

      } catch (error) {
        console.error('❌ Chyba při manipulaci s notifikacemi:', error);
      }
    });
  }
};

App.scrollbar();
App.inits();
